import { Component, OnInit, ViewChild } from '@angular/core';
import { LogService } from '../../services/log.service';
import { BaseForm } from '../../interfaces/BaseForm';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../services/session.service';
import { AuditService } from '../../services/audit.service';
import { SessionStorageService } from 'app/services/session-storage.service';
import  {ViewEncapsulation} from '@angular/core'
//import { ViewEncapsulation } from '@angular/compiler/src/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RouterService } from 'app/services/router.service';
import { PrivacyNoticeService } from 'app/services/privacy.service';

@Component({
  selector: 'app-user-privacy-notice',
  templateUrl: './user-privacy-notice.component.html',
  styleUrls: ['./user-privacy-notice.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrivacyNoticeComponent extends BaseForm implements OnInit {
  private _jsonURL="assets/data/privacynoticenew.json";
  public version :string;
  public terms1:string;
  public terms2:string;
  public terms3:string;
  public title :string;
  public body1:string;
  public body2:string;
  public body3:string;
  public body4:string;
  public body5:string;
  public body6:string;
  public body7:string;
  public body8:string;
  public body9:string;
  public body10:string;
  public body11:string;
  public body12:string;
  public body13:string;
  public body14:string;
  public body15:string;
  public body16:string;
  public body17:string;
  public body18:string;
  constructor(
    private log: LogService,
    private auditService: AuditService,
    private sessionStorage: SessionStorageService,
    public activeModal: NgbActiveModal,
    private http: HttpClient,
    private routerService: RouterService,
    private privacyNoticeService: PrivacyNoticeService
   ) {
    super(log);
  }
  public getJSON(): Observable<any>{
    return this.http.get(this._jsonURL)
  }
  ngOnInit() {
    this.clear();
    this.getJSON().subscribe(data =>{
      console.log(data);
            
      this.version=data.version;
      this.title=data.title;
      this.terms1=data.terms1;
      this.terms2=data.terms2;
      this.terms3=data.terms3;
      this.body1=data.body1;
      this.body2=data.body2;
      this.body3=data.body3;
      this.body4=data.body4;
      this.body5=data.body5;
      this.body6=data.body6;
      this.body7=data.body7;
      this.body8=data.body8;
      this.body9=data.body9;
      this.body10=data.body10;
      this.body11=data.body11;
      this.body12=data.body12;
      this.body13=data.body13;
      this.body14=data.body14;
      this.body15=data.body15;
      this.body16=data.body16;
      this.body17=data.body17;
      this.body18=data.body18;
    });
    this.privacyNoticeService.setPrivacyNoticeOpen();

  }
 
  isValid(): boolean {
    console.log("isValid:")
    
    return true;
  }
  clear() {
    this.isSuccess = false;
  }
  close() {
    this.activeModal.close();
  }

  Logout(){
    this.auditService.auditEvent(
      this.privacyNoticeService.getUser().username,
      'Privacy-Notice: ',
      'User response: declined privacy notice-'+this.version,
      {
        organizationName: this.sessionStorage.getOrganization().OrganizationName,
        Facility: this.sessionStorage.getOrganization().Facilities,
        role: this.privacyNoticeService.getUser().securityGroups
      }
    );
    this.privacyNoticeService.actionUserDecline(
      this.privacyNoticeService.getUser().organization.UserPoolId,
      this.privacyNoticeService.getUser().username
    );
    this.privacyNoticeService.setPrivacyNoticeClose();
    this.close()

    this.routerService.gotoLogout();
  }

  submit() {
    this.auditService.auditEvent(
      this.privacyNoticeService.getUser().username,
      'Privacy-Notice: '+this.version,
      'User response: Accepted privacy notice-'+this.version,
      {
        organizationName: this.sessionStorage.getOrganization().OrganizationName,
        Facility: this.sessionStorage.getOrganization().Facilities,
        role: this.privacyNoticeService.getUser().securityGroups
      }
    );
    this.privacyNoticeService.actionUserAccept(
      this.privacyNoticeService.getUser().organization.UserPoolId,
      this.privacyNoticeService.getUser().username
    );
    this.privacyNoticeService.setPrivacyNoticeClose();
    this.log.trace('SessionService UUX Session ID:', this.sessionStorage.getUUXSessionId());
    this.log.trace('SessionService user Pool ID:', this.privacyNoticeService.getUser().organization.UserPoolId);
    this.log.trace('SessionService user name:', this.privacyNoticeService.getUser().username);
    this.log.trace('SessionService version:', this.version);
    this.close()
  }
   
}

